const $ = require('jquery');

const $popOut = $('.pop-out');
const $popOutImage = $('.pop-out-image');
// Bool used for hovering to determine if the animation should continue or not
let isHovering = false;
// Sets bool to ensure it doesn't hide on mouse leave if it hasn't been 5 seconds
let isAnimating = false;

$(window).load(() => {
  if (window.matchMedia('(min-width: 768px)').matches) {
    if ($popOut.length > 0) {
      // Bind Hover
      $popOut.mouseenter(HoverIn);
      $popOut.mouseleave(HoverOut);
      // Start Animation
      setTimeout(popOut, 250);
    }
  }
});

// Pops out into the screen (shows)
function popOut() {
  $popOut.addClass('popped-out');
  setTimeout(pop, 1500);
}

// Pops (Bulges)
function pop() {
  $popOutImage.addClass('tada');
  setTimeout(dePop, 1000);

  isAnimating = true;
  setTimeout(popIn, 5000);
}

// Removed Pop
function dePop() {
  $popOutImage.removeClass('tada');
}

// Pops back in (hides)
function popIn() {
  isAnimating = false;
  if (isHovering === false) {
    $popOut.removeClass('popped-out');
  }
}

// Hover In
function HoverIn() {
  isHovering = true;
}

// Hover Out
function HoverOut() {
  isHovering = false;
  if (!isAnimating) {
    setTimeout(popIn, 200);
  }
}
